module.exports = __webpack_public_path__ + "img/erp.d513fdf6.jpg";